module.exports = __webpack_public_path__ + "static/media/8.ce1913e1.png";